import { CrudService } from 'ui-shared';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AtributoReceitaNcmEntity } from "@catalogo/models";
import { CONFIGURACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";

@Injectable({ providedIn: 'root' })
export class AtributoReceitaNcmDataService extends CrudService<AtributoReceitaNcmEntity> {
    protected url: string;
    urlOriginal: string;

    constructor(
        @Inject(CONFIGURACAO_API_URL) urlBase: string,
        @Inject(HttpClient) protected httpClient: HttpClient
    ) {
        super(urlBase, httpClient);
        this.urlOriginal = `${urlBase}/v1/atributoreceita/<parentId>/ncm`;
    }

    public withParentId(parentId: string) {
        this.url = this.urlOriginal.replace('<parentId>', parentId);
        return this;
    }
}
